
import { mapState, mapActions, mapGetters } from "vuex";
import VueHtml2pdf from "vue-html2pdf";
import invoicesDetailed from "./invoices-detailed.vue";
import CurrencyConverter from "../common/currency-converter.vue";
export default {
  components: { invoicesDetailed, VueHtml2pdf, CurrencyConverter },
  data() {
    return {
      invoiceDetailsLoading: false,
      invoiceData: {}
    };
  },
  props: {
    item: {
      default: {}
    }
  },
  computed: {
    ...mapState("restaurant", ["locationDetails", "businessDetails"])
  },
  methods: {
    ...mapActions("payment", ["getInvoiceDetail"]),
    downloadInvoice() {
      this.invoiceDetailsLoading = true;
      this.getInvoiceDetail({
        id: this.item.id,
        params: { location_id: this.locationDetails.id }
      })
        .then(async (data) => {
          this.invoiceData = data?.data;
          await this.sleep(1000);
          this.$refs["html2Pdf__invoice"].generatePdf();
        })
        .finally(() => {
          this.invoiceDetailsLoading = false;
        });
    },
    getFileName() {
      return `Invoice_${this.businessDetails.name}`;
    }
  }
};
